export interface IMenu {
  imgUrl: string;
  imgActiveUrl: string;
  imgWidth: number;
  imgHeight: number;
  text: string;
  href: string;
}

export const menusData: IMenu[] = [
  {
    imgUrl: "home.svg",
    imgActiveUrl: "home-active.svg",
    imgWidth: 24,
    imgHeight: 24,
    text: "mobile.menu_home",
    href: "/",
  },
  {
    imgUrl: "category.svg",
    imgActiveUrl: "category-active.svg",
    imgWidth: 23,
    imgHeight: 23,
    text: "mobile.menu_category",
    href: "/mall",
  },
  {
    imgUrl: "cart.svg",
    imgActiveUrl: "cart-active.svg",
    imgWidth: 23,
    imgHeight: 23,
    text: "mobile.menu_cart",
    href: "/cart",
  },
  {
    imgUrl: "user.svg",
    imgActiveUrl: "user-active.svg",
    imgWidth: 24,
    imgHeight: 24,
    text: "mobile.menu_my",
    href: "/user",
  },
];
